import { classNames } from "primereact/utils";

import { Icon } from "../icon";
import styles from "./dialog-header.module.scss";
import type { DialogHeaderViewModel } from "./types-dialog-header";

export function DialogHeaderView({
  title,
  subtitle,
  icon,
  tone,
  classNames: parts,
  rootClassName,
  rest,
}: DialogHeaderViewModel) {
  return (
    <div className={classNames(styles.root, rootClassName)} {...rest}>
      {icon ? (
        <span className={classNames(styles.badge, styles[tone], parts.badge)} data-tone={tone}>
          <Icon name={icon} size={20} />
        </span>
      ) : null}
      <span className={styles.text}>
        <span className={classNames(styles.title, parts.title)}>{title}</span>
        {subtitle ? (
          <span className={classNames(styles.subtitle, parts.subtitle)}>{subtitle}</span>
        ) : null}
      </span>
    </div>
  );
}
